import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";

import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { DF_CO0009Context } from "../context";
import useGetHeightPage from "../../../../Hooks/useGetHeightPage";

function GridBody() {
  const { parseParams } = useContext(DF_CO0009Context);

  const ID_Arquivo = parseParams.get("ID_Arquivo");

  const { userProfile, access_token } = useSelector((state) => ({
    userProfile: state.login.profile,
    access_token: state.login.user.access_token,
  }));

  useGetHeightPage();

  const csrfToken = useGetCsrfToken();

  const [loading, setLoading] = useState(false);

  const [screenMode, setScreenMode] = useState("confirm");

  const handleCloseModal = (reload = false) => {
    if (window.top !== window.self) {
      window.parent.postMessage(
        {
          type: "closeModal",
          isReloadPage: reload,
        },
        "*",
      );
    } else {
      window.close();
    }
  };

  const handleReprocessar = async () => {
    try {
      setLoading(true);

      await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: userProfile.ID_Usuario,
        },
        "EDI_Kernel_Set_Reprocessamento_Com_Erro_Manual",
        csrfToken,
        access_token,
      );

      setScreenMode("success");
    } catch (error) {
      console.log("erro:", error);

      setScreenMode("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {screenMode === "confirm" && (
        <div>
          <div className="text-center">
            <div className="icon-warning mb-4">
              <i className="fas fa-exclamation-triangle"></i>
            </div>

            <h5 className="modal-title-custom mb-3">
              Deseja reprocessar o documento de
              <br />
              Nota Fiscal?
            </h5>

            <p className="modal-description mb-4">
              Ao clicar em ‘Confirmar’, o documento será
              <br />
              reprocessado.
            </p>

            <div className="d-flex justify-content-center gap-3">
              <button
                className="btn border-0 fw-bold px-4 btn-cancelar-co0005"
                onClick={() => handleCloseModal(false)}
                disabled={loading}
              >
                Cancelar
              </button>

              <button
                className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
                onClick={handleReprocessar}
                disabled={loading}
              >
                {loading ? "Processando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}

      {screenMode === "success" && (
        <div>
          <div className="text-center">
            <div className="icon-success mb-4">
              <i className="fas fa-check"></i>
            </div>

            <h5 className="modal-title-custom mb-3">Sucesso!</h5>

            <p className="modal-subtext mb-4">
              Operação realizada com sucesso!
            </p>

            <button
              className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
              onClick={() => handleCloseModal(true)}
            >
              Ok!
            </button>
          </div>
        </div>
      )}

      {screenMode === "error" && (
        <div>
          <div className="text-center">
            <div className="icon-error mb-4">
              <i className="fas fa-times"></i>
            </div>

            <h5 className="modal-title-custom mb-4">
              Erro em reprocessar o documento
            </h5>

            <p className="modal-description mb-4">
              Repita o processo novamente para concluir o
              <br />
              reprocessamento com sucesso.
            </p>

            <div className="d-flex justify-content-center">
              <button
                className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
                onClick={() => setScreenMode("confirm")}
              >
                Ok!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default GridBody;
